export interface Messenger451 {
  open: () => void;
}

export interface BoltDiscovery {
  open: () => void;
  ask: (question: string) => void;
  openPreviousThreads: () => void;
}

export interface Shell451Window extends Window {
  Shell451: {
    _shells: Set<string>;
    Messenger451: Messenger451;
    BoltDiscovery: BoltDiscovery;
  };
}

export const getShellWindow = () => window as unknown as Shell451Window;
